export const reliability = [
  {
    title: "مقیاس‌پذیری بی‌وقفه",
    desc: "رشد زیرساخت متناسب با نیاز شما",
    logo: "disaster.svg",
    imgAlt: "مقیاس‌پذیری بی‌وقفه",
    imgTitle: "مقیاس‌پذیری بی‌وقفه",
  },
  {
    title: "پایداری و اطمینان بالا",
    desc: "اجرای بدون وقفه سرویس‌ها حتی در صورت بروز بحران",
    logo: "startup.svg",
    imgAlt: "پایداری و اطمینان بالا",
    imgTitle: "پایداری و اطمینان بالا",
  },
  {
    title: "سادگی در مدیریت",
    desc: "رایانش ابری در بالاترین سطح بدون نیاز به دانش کلود",
    logo: "virtualOrganization.svg",
    imgAlt: "سادگی در مدیریت",
    imgTitle: "سادگی در مدیریت",
  },
  {
    title: "امنیت پیشرفته و به‌روز",
    desc: "محافظت چند لایه با به‌روزرسانی مداوم",
    logo: "test.svg",
    imgAlt: "امنیت پیشرفته و به‌روز",
    imgTitle: "امنیت پیشرفته و به‌روز",
  },
];

export const features = [
  {
    img: "focus.svg",
    title: "پیاده‌سازی معماری ابری دلخواه",
    desc: "با همراهی تیم متخصص حوزه ابر آبالون، پیچیده‌ترین سناریوهای ابری را به‌سادگی طراحی و پیاده‌سازی کنید.",
    imgAlt: "پیاده‌سازی معماری ابری دلخواه",
    imgTitle: "پیاده‌سازی معماری ابری دلخواه",
  },
  {
    img: "monitoring.svg",
    title: "پنل پیشرفته مدیریتی",
    desc: "با پنل پیشرفته تحت وب، حتی با قطع شدن دسترسی به اینترنت، امکان اتصال برای شما فراهم است.",
    imgAlt: "پنل پیشرفته مدیریتی",
    imgTitle: "پنل پیشرفته مدیریتی",
  },
  {
    img: "technical.svg",
    title: "دسترسی از تمام جهان",
    desc: "چه در داخل ایران و چه در خارج، در هر زمان به منابع و سرویس‌های ابری خود متصل شوید.",
    imgAlt: "دسترسی از تمام جهان",
    imgTitle: "دسترسی از تمام جهان",
  },
  {
    img: "devops.svg",
    title: "فایروال پیشرفته قابل تنظیم",
    desc: "در تنظیمات فایروال، رول‌های امنیتی خود را برای هر سرور یا کل دیتاسنتر تعریف و مدیریت کنید.",
    imgAlt: "فایروال پیشرفته قابل تنظیم",
    imgTitle: "فایروال پیشرفته قابل تنظیم",
  },
  {
    img: "agility.svg",
    title: "پشتیبانی شبانه‌روزی",
    desc: "تیم فنی آبالون به‌صورت ۲۴/۷/۳۶۵ آماده پاسخگویی و پشتیبانی از سرور ابری یا دیتاسنتر ابری شماست.",
    imgAlt: "پشتیبانی شبانه‌روزی",
    imgTitle: "پشتیبانی شبانه‌روزی",
  },
  {
    img: "hardening.svg",
    title: "پایداری و آپ‌تایم تضمین‌شده",
    desc: "تمامی خدمات رایانش ابری آبالون با سطح دسترس‌پذیری تا ۹۹.۹۹٪ ارائه می‌شوند.",
    imgAlt: "پایداری و آپ‌تایم تضمین‌شده",
    imgTitle: "پایداری و آپ‌تایم تضمین‌شده",
  },
];

export const popularServices = [
  {
    title: "محصولات آبالون",
    desc: "با استفاده از محصولات ابری و دیتاسنتری آبالون، زیرساخت امن، پایدار و مقیاس‌پذیر سازمان‌تان را بدون پیچیدگی‌های فنی ایجاد کنید.",
    logo: "CloudGuard-Service.svg",
    route: "/products",
  },
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه SIEM از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "VPS-Service.svg",
    route: "/cloud-security",
  },
  {
    title: "راهکارهای تخصصی آبالون",
    desc: "با راهکارهای تخصصی آبالون، بدون پیچیدگی فنی، مسیر مهاجرت، مدیریت و امنیت ابری را ساده‌تر کنید و در مسیر رشد و تحول دیجیتال سازمان را شتاب دهید.",
    logo: "VPC-Service.svg",
    route: "/solutions",
  },
  {
    title: "شبکه ابری آبالون",
    desc: "با شبکه ابری آبالون، ترافیک سازمان‌تان را بهینه مدیریت کنید، محدودیت‌های دسترسی را برطرف کنید و اتصال پایدار و امن را تجربه کنید.",
    logo: "ManagedService-Service.svg",
    route: "/network",
  },
];

export const questions = [
  {
    title: "سرویس‌های رایانش ابری آبالون شامل چه مواردی می‌شود؟",
    answer:
      "رایانش ابری آبالون شامل سرورهای ابری مقیاس‌پذیر (VPS) و دیتاسنترهای ابری اختصاصی (VPC) است. این سرویس‌ها امکان راه‌اندازی سریع زیرساخت، مدیریت یکپارچه و مقیاس‌پذیری لحظه‌ای منابع را در اختیار شما قرار می‌دهند.",
  },
  {
    title: "تفاوت سرور ابری (VPS) و دیتاسنتر ابری (VPC) چیست؟",
    answer:
      "سرور ابری (VPS) یک ماشین مجازی قدرتمند است که در کمتر از یک دقیقه آماده استفاده می‌شود و گزینه‌ای مقرون‌به‌صرفه برای اجرای سرویس‌هاست. دیتاسنتر ابری (VPC) محیطی اختصاصی و ایزوله است که به شما امکان می‌دهد تعداد نامحدودی ماشین مجازی ایجاد کنید، آن‌ها را در یک پنل واحد مدیریت کنید و معماری‌های پیچیده سازمانی خود را مانند یک دیتاسنتر فیزیکی، روی بستر ابر پیاده‌سازی کنید.",
  },
  {
    title:
      "آیا در سرویس‌های رایانش ابری، امکان ارتقا یا کاهش لحظه‌ای منابع سرور ابری وجود دارد؟",
    answer:
      "بله. در رایانش ابری آبالون می‌توانید منابع سرور مانند CPU، RAM و فضای ذخیره‌سازی را به‌صورت لحظه‌ای تغییر دهید و هزینه‌ها را بر اساس نیاز خود مدیریت کنید.",
  },
  {
    title:
      "مزیت استفاده از رایانش ابری آبالون نسبت به خرید سخت‌افزار فیزیکی چیست؟",
    answer:
      "با رایانش ابری آبالون، می‌توانید سرویس‌ها را در چند دقیقه راه‌اندازی کنید و بدون نیاز به نیروی متخصص، تمام ماشین‌های مجازی خود را در یک پنل مدیریت کنید. دیگر ظرفیت محدود سخت‌افزار را تجربه نخواهید کرد، زیرا امکان ایجاد تعداد نامحدود ماشین مجازی و آی‌پی عمومی، انتقال آسان بین سطوح کیفی مختلف و همچنین طراحی معماری‌های سفارشی به همراه مدیریت شبکه، فایروال و دیسک‌های مجازی به طور کامل در اختیار شماست.",
  },
];
